export default __webpack_public_path__ + "static/pic3-2a9672fd4dc2bdb55fd3ab279e8595ef.jpg";